module.exports = __webpack_public_path__ + "img/t5-gray.46df750a.png";